import { Instagram, Facebook } from "lucide-react";

const PulseDot = () => (
  <span className="relative flex h-2 w-2">
    <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-cyan-400 opacity-60" />
    <span className="relative inline-flex h-2 w-2 rounded-full bg-cyan-300" />
  </span>
);

export const Navbar = () => (
  <header data-testid="site-navbar" className="fixed inset-x-0 top-0 z-50 border-b border-white/5 bg-ink/70 backdrop-blur-xl">
    <nav className="mx-auto flex max-w-7xl items-center justify-between px-5 py-4 sm:px-8">
      <a data-testid="nav-logo-link" href="#top" className="flex items-center gap-3">
        <img src="/assets/logo-512.png" alt="The Open Tale globe logo" className="h-9 w-9 drop-shadow-[0_0_14px_rgba(6,182,212,0.5)]" />
        <span className="font-display text-sm font-extrabold tracking-wide sm:text-base">
          The Open <span className="brand-gradient-text">Tale</span>
        </span>
      </a>
      <div className="flex items-center gap-2 sm:gap-3">
        <span
          data-testid="nav-coming-soon-pill"
          className="hidden items-center gap-2 rounded-full border border-cyan-400/30 bg-cyan-400/10 px-3 py-1.5 font-mono text-[10px] tracking-[0.25em] text-cyan-300 sm:inline-flex"
        >
          <PulseDot /> COMING SOON
        </span>
        <a
          data-testid="nav-instagram-link"
          href="https://www.instagram.com/theopentale/"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="The Open Tale on Instagram"
          className="rounded-full border border-white/10 p-2 text-slate-300 transition-colors duration-300 hover:border-cyan-400/50 hover:text-cyan-300"
        >
          <Instagram className="h-4 w-4" />
        </a>
        <a
          data-testid="nav-facebook-link"
          href="https://www.facebook.com/theopentale/"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="The Open Tale on Facebook"
          className="rounded-full border border-white/10 p-2 text-slate-300 transition-colors duration-300 hover:border-cyan-400/50 hover:text-cyan-300"
        >
          <Facebook className="h-4 w-4" />
        </a>
      </div>
    </nav>
  </header>
);
